<template>
  <div class="select-form-wrapper">
    <label for="select-state">
      Select a state:
      <br />
    </label>
    <select @change="handleStateClick" id="select-state">
      <option value>Select a state</option>
      <option v-for="state in allStates[0]" :key="state[5]" :value="state[5]">{{state[0]}}</option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    allStates: Array,
    currentState: Array
  },
  data() {
    return {
      value: ""
    };
  },
  methods: {
    handleStateClick() {
      this.$emit("select-event", event.target);
    },
    changeValue() {
      let select = document.querySelector(".select-form-wrapper select");
      select.options[0].selected = true;
    }
  },
  watch: {
    currentState() {
      this.changeValue();
    }
  }
};
</script>

<style scoped>
.select-form-wrapper {
  min-height: 100px;
}
</style>